import * as Sentry from '@sentry/nextjs';
import { sentryDsn, sentryEnabled, environment } from '@/lib/config/env';

if (sentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    environment,
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    debug: false,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
